// Injeta um <link rel="stylesheet"> no <head> com a fonte do Google Fonts
// solicitada. Idempotente por família — chamadas repetidas com a mesma fonte
// não duplicam tags. Use em previews (ThemeConfigPage) ou para pré-carregar
// um conjunto de opções.
//
// O ThemeContext usa um link próprio (`reviter-dynamic-font`) pra fonte ativa
// da loja; aqui usamos IDs distintos (`reviter-preview-font-<slug>`) pra não
// conflitar.

const PREVIEW_PREFIX = 'reviter-preview-font-';

function slugify(family) {
  return String(family).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}

export function loadGoogleFont(family) {
  if (typeof document === 'undefined') return;
  const name = (family || '').trim();
  if (!name) return;
  const id = `${PREVIEW_PREFIX}${slugify(name)}`;
  if (document.getElementById(id)) return;

  const familyParam = name.replace(/\s+/g, '+');
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${familyParam}:wght@400;500;600;700&display=swap`;
  document.head.appendChild(link);
}

// Pré-carrega múltiplas fontes de uma vez (ex: ao montar a tela de tema).
export function preloadGoogleFonts(families) {
  if (!Array.isArray(families)) return;
  families.forEach(loadGoogleFont);
}
